import { Grid } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { IfRender, PrimaryButton } from 'library';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import { IRow } from './models';
import { useWidth } from 'reusableComponents/useWidth';
import InviteMenuModal from './components/InviteMenuModal';
import InviteMenuPopup from './components/InviteMenuPopup';
import InviteCopySuccessAlert from './components/InviteCopySuccessAlert';
import InviteModal from './components/InviteModal/InviteModal';
import { client, consoleLogInDev, track } from 'shared';
import { useUserContext } from 'UserContext';
import { IGroup } from 'parent-portal/group/models';
import { useLocation } from 'react-router-dom';
import { trackReferralEngagement } from 'api/UserApi';

export default function InviteDropdown({ group }: { group: IGroup }) {
    const { user } = useUserContext();
    const location = useLocation();
    const breakpoint = useWidth();
    const showModal = breakpoint === 'xs';
    const [openMenu, setOpenMenu] = useState(false);
    const [openAlert, setOpenAlert] = useState(false);
    const [openInviteModal, setOpenInviteModal] = useState(false);
    const [inviteLink, setInviteLink] = useState('');

    const rows: IRow[] = [
        {
            icon: <PersonAddIcon />,
            title: 'Invite with email',
            subtitle: 'Send an email to invite people to this group',
            action: emailAction,
        },
        {
            icon: <MailOutlineIcon />,
            title: 'Invite with link',
            subtitle: 'Send a link to invite people to this group',
            action: linkAction,
        },
    ];

    useEffect(() => {
        if (group && user) {
            setInviteLink(`${window.location.origin}/?referral=${user.referral_code}&group=${group.id}`);
        }
    }, [group]);

    function linkAction() {
        if (user) {
            trackReferralEngagement(user.id, location.pathname, 'Group: Copy Link')
                .then((response) => {
                    navigator.clipboard.writeText(`${inviteLink}&reid=${response.id}`);
                })
                .catch((error) => {
                    consoleLogInDev(error);
                    navigator.clipboard.writeText(inviteLink);
                })
                .finally(() => {
                    setOpenMenu(false);
                    setOpenAlert(true);
                });
        }
        track('Groups: Link Invite Button Clicked');
    }

    function emailAction() {
        track('Groups: Email Invite Button Clicked');
        setOpenMenu(false);
        setOpenInviteModal(true);
    }

    return (
        <Grid item>
            <div style={{ position: 'relative' }}>
                <PrimaryButton onClick={() => setOpenMenu(true)}>Invite</PrimaryButton>
                <IfRender condition={openMenu && !showModal}>
                    <InviteMenuPopup rows={rows} setOpenMenu={setOpenMenu} />
                </IfRender>
                <IfRender condition={openMenu && showModal}>
                    <InviteMenuModal rows={rows} setOpenMenu={setOpenMenu} />
                </IfRender>
            </div>
            <InviteCopySuccessAlert open={openAlert} onClose={() => setOpenAlert(false)} />
            <InviteModal open={openInviteModal} onClose={() => setOpenInviteModal(false)} inviteLink={inviteLink} />
        </Grid>
    );
}
